import { render, staticRenderFns } from "./FixedAdd.vue?vue&type=template&id=dbd5a3ec&scoped=true"
import script from "./FixedAdd.vue?vue&type=script&lang=js"
export * from "./FixedAdd.vue?vue&type=script&lang=js"
import style0 from "./FixedAdd.vue?vue&type=style&index=0&id=dbd5a3ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd5a3ec",
  null
  
)

export default component.exports